import React from 'react'
import { Spinner } from 'react-bootstrap'
import { BiAnalyse } from 'react-icons/bi'

/**
 * SortingModal Component
 * 
 * Loading indicator modal displayed while sorting datatable results. Shows spinning loader
 * with informational text about sorting operation in progress. Used in floating alerts during
 * async sort operations on large datasets.
 * 
 * @returns {JSX.Element} Loading indicator with spinner and sorting status message
 */
const SortingModal = () => {
  return (
    <div style={{ display: "flex", paddingTop: "10px" }}>
      <div style={{ width: "90%" }}>
        <p style={{ color: "#0f9d58" }}>
          <BiAnalyse className="alert-icon" /> Sorting
        </p>
        <p style={{ marginLeft: "28px" }}>
          We'll notify you once your results are ready.
        </p>
      </div>
      <div style={{ width: "10%", textAlign: "right" }}>
        <Spinner animation="border" variant="secondary" />
      </div>
    </div>
  )
}

export default SortingModal